/**
 * What the skill Settings offer (`GET /skills/options`): event labels,
 * confirm-before areas, schedule frequencies, case statuses. Fetched once
 * per firm scope and shared.
 */
import { useEffect, useState } from "react";

import { firmKnowledgeApi, type FirmScope } from "@/api/firm-knowledge";
import type { SkillOptions } from "../types";

const cache = new Map<string, Promise<SkillOptions>>();

export const useSkillOptions = (scope: FirmScope): SkillOptions | null => {
  const key = JSON.stringify(scope ?? {});
  const [options, setOptions] = useState<SkillOptions | null>(null);
  useEffect(() => {
    let cancelled = false;
    let pending = cache.get(key);
    if (!pending) {
      pending = firmKnowledgeApi.getSkillOptions(scope);
      cache.set(key, pending);
      pending.catch(() => cache.delete(key));
    }
    pending
      .then((o) => {
        if (!cancelled) setOptions(o);
      })
      .catch(() => undefined);
    return () => {
      cancelled = true;
    };
  }, [key]);
  return options;
};
